"use client";
import React from "react";
import { Input, Textarea } from "@heroui/input";
import { Icon } from "@iconify/react";
import { Button } from "@heroui/button";

import useContactForm from "./useContactForm";

const ContactForm = () => {
  const { contactLoading, contactPayload, setContactPayload, handleSubmit } =
    useContactForm();

  return (
    <form
      className=" lg:border-foreground-200 lg:border lg:rounded-xl lg:p-8"
      data-aos="fade-up"
      onSubmit={handleSubmit}
    >
      <div className="  md:text-4xl text-2xl mb-4 font-bold">
        Send us a message
      </div>
      <div className="flex items-start md:flex-row mt-4 flex-col justify-between gap-4">
        <Input
          fullWidth
          classNames={{
            input: "text-base",
          }}
          isRequired={true}
          label="First name"
          labelPlacement="outside"
          minLength={2}
          placeholder="Type your first name"
          radius="sm"
          validationBehavior="native"
          value={contactPayload.firstName}
          variant="bordered"
          onValueChange={(value: string) =>
            setContactPayload((prev) => ({
              ...prev,
              firstName: value,
            }))
          }
        />
        <Input
          fullWidth
          classNames={{
            input: "text-base",
          }}
          isRequired={true}
          label="Last name"
          labelPlacement="outside"
          minLength={2}
          placeholder="Type your last name"
          radius="sm"
          validationBehavior="native"
          value={contactPayload.lastName}
          variant="bordered"
          onValueChange={(value: string) =>
            setContactPayload((prev) => ({
              ...prev,
              lastName: value,
            }))
          }
        />
      </div>

      <Input
        fullWidth
        classNames={{
          input: "text-base",
          mainWrapper: "mt-4",
        }}
        isRequired={true}
        label="Email"
        labelPlacement="outside"
        placeholder="Type your email"
        radius="sm"
        startContent={
          <Icon className="text-foreground-400" icon="ri:mail-fill" />
        }
        type="email"
        validationBehavior="native"
        value={contactPayload.email}
        variant="bordered"
        onValueChange={(value: string) =>
          setContactPayload((prev) => ({
            ...prev,
            email: value,
          }))
        }
      />

      <Input
        fullWidth
        classNames={{
          input: "text-base",
          mainWrapper: "mt-4",
        }}
        isRequired={true}
        label="Phone number"
        labelPlacement="outside"
        placeholder="(+234) 8011 111 111"
        radius="sm"
        startContent={
          <Icon className="text-foreground-400" icon="ri:phone-fill" />
        }
        validationBehavior="native"
        value={contactPayload.phoneNumber}
        variant="bordered"
        onValueChange={(value: string) =>
          setContactPayload((prev) => ({
            ...prev,
            phoneNumber: value,
          }))
        }
      />

      <Input
        fullWidth
        classNames={{
          mainWrapper: "mt-4",
          input: "text-base",
        }}
        isRequired={true}
        label="Subject"
        labelPlacement="outside"
        placeholder="What is your inquiry about?"
        radius="sm"
        validationBehavior="native"
        value={contactPayload.subject}
        variant="bordered"
        onValueChange={(value: string) =>
          setContactPayload((prev) => ({
            ...prev,
            subject: value,
          }))
        }
      />

      <Textarea
        fullWidth
        className="mt-4"
        classNames={{
          input: "text-base",
        }}
        label={
          <>
            <span>Message</span>
            <span className="text-foreground-600">(Optional)</span>
          </>
        }
        labelPlacement="outside"
        placeholder="Write your message here"
        radius="sm"
        validationBehavior="native"
        value={contactPayload.message ?? ""}
        variant="bordered"
        onValueChange={(value: string) =>
          setContactPayload((prev) => ({
            ...prev,
            message: value,
          }))
        }
      />

      <div className="p-0 mt-6 flex-col items-center space-y-4 ">
        <Button
          fullWidth
          color="primary"
          isLoading={contactLoading}
          type="submit"
        >
          {!contactLoading && <span>Send Message</span>}
        </Button>
      </div>
    </form>
  );
};

export default ContactForm;
